import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NavbarIconsCatalogPhases from "../generic-nav-bar/NavbarIconsCatalogPhases";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { useTracking } from "react-tracking";
import { catalogPhaseCleanSearchText, catalogPhaseStartDelete, cleanCatalogPhaseLevel1, cleanCatalogPhaseLevel2, cleanCatalogPhaseLevel3, cleanCatalogPhaseLevel4, cleanSearchingCatalogPhasesPaginated, selectCatalogPhaseLevel1, selectCatalogPhaseLevel2, selectCatalogPhaseLevel3, selectCatalogPhaseLevel4, selectCatalogPhases, startLoadingCatalogPhaseByParent, startLoadingCatalogPhasesByLevel1, startLoadingCatalogPhasesNoLevel6, startLoadingCatalogPhasesPaginated, startSearchingCatalogPhasesPaginated } from "../../app/actions/catalogPhaseActions";
import { debugLogPages } from "../../app/helpers/debugHelper";
import SearchBackCatalogPhase from "../generic-search/SearchBackCatalogPhase";
import ReactPaginateComponent from "../generic-ui/ReactPaginateComponent";
import SimpleSelect from "../generic-ui/Select";
import TableCatalogPhases from "./TableCatalogPhases";

const ID_FORM = "admin-phase";
const OPERATION = "list";

const listOptions = [2, 3, 4, 5, 10, 15, 20, 25, 50, 100];

const ListCatalogPhases = () => {
  debugLogPages(':: ListCatalogPhases');

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const { searchTextState, catalogPhasesS, catalogPhasesP, totalPagesP, totalPagesS, currentPageS,
    listCatalogPhasesLevel1, listCatalogPhasesLevel2, listCatalogPhasesLevel3,
    listCatalogPhasesLevel4
  } = useSelector((state) => state.catalogPhase);


  const [, setCurrentPageClick] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageInitial] = useState(0);
  const [searchText, setSearchText] = useState(searchTextState || "");
  const [catalogPhaseLevel1, setCatalogPhaseLevel1] = useState("");
  const [catalogPhaseLevel2, setCatalogPhaseLevel2] = useState("");
  const [catalogPhaseLevel3, setCatalogPhaseLevel3] = useState("");
  const [catalogPhaseLevel4, setCatalogPhaseLevel4] = useState("");
  const [isDisabledSearchText, setIsDisabledSearchText] = useState(false);
  const [isDisabledFilter, setIsDisabledFilter] = useState(false);

  useEffect(() => {
    //First Clean list and searchText
    dispatch(cleanSearchingCatalogPhasesPaginated());
    dispatch(catalogPhaseCleanSearchText());
    //Load Data
    
    dispatch(startLoadingCatalogPhasesPaginated(pageInitial, itemsPerPage));
    setSearchText("");

    dispatch(startLoadingCatalogPhasesNoLevel6())
    
    dispatch(startLoadingCatalogPhasesByLevel1(1));
  }, []);

  const onEditRow = (row) => {
    trackEvent({ component: "EditCatalogPhases", method: "onEditRow", event: "EditCatalogPhases-Clicked" });

    dispatch(selectCatalogPhases(row));
    if (catalogPhasesS?.length > 0) {
      navigate("/admin-phase/edit-phase", {
        state: { searchTextNavListUser: searchText },
      });
    } else {
      navigate("/admin-phase/edit-phase");
    }
  };

  const onDeleteRow = (row) => {
    trackEvent({ component: "DeleteCatalogPhases", method: "onDeleteRow", event: "DeleteCatalogPhases-Clicked" });
    dispatch(catalogPhaseStartDelete(row.id));
  };

  const onPageChangeReactPaginate = (pageClick) => {
    const pageClickRP = pageClick && pageClick.selected + 1

    if (catalogPhasesS && catalogPhasesS.length > 0) {
      dispatch(startSearchingCatalogPhasesPaginated(searchText, pageClickRP - 1, itemsPerPage));
    } else {
      dispatch(startLoadingCatalogPhasesPaginated(pageClickRP - 1, itemsPerPage));
    }
    setCurrentPageClick(pageClick);
  };

  const onChangeSelect = (event) => {
    setItemsPerPage(event.target.value);
    if (catalogPhasesS && catalogPhasesS.length > 0) {
      dispatch(startSearchingCatalogPhasesPaginated(searchText, 0, event.target.value));
    } else {
      dispatch(startLoadingCatalogPhasesPaginated(0, event.target.value));
    }
    setCurrentPageClick(0);
    setItemsPerPage(event.target.value);
  };

  const handleChangePhaseLevel1 = (event) => {
    
    if (event != null) {

      setIsDisabledSearchText(true);
      setIsDisabledFilter(false);

      
      if (event.code === 0) {

        setCatalogPhaseLevel1(event);

        dispatch(cleanCatalogPhaseLevel1());

        dispatch(selectCatalogPhaseLevel1(event));

        setCatalogPhaseLevel2("");
        setCatalogPhaseLevel3("");
        setCatalogPhaseLevel4("");

      } else {

        setCatalogPhaseLevel1(event);

        dispatch(cleanCatalogPhaseLevel1());

        dispatch(selectCatalogPhaseLevel1(event));

        setCatalogPhaseLevel2("");
        setCatalogPhaseLevel3("");
        setCatalogPhaseLevel4("");

        dispatch(startLoadingCatalogPhasesPaginated(pageInitial, itemsPerPage, event));

        dispatch(startLoadingCatalogPhaseByParent(event.id, 2));
      }
    } else {

      setIsDisabledSearchText(false);
      setIsDisabledFilter(false);



      dispatch(cleanCatalogPhaseLevel1());
      setCatalogPhaseLevel1("");
      setCatalogPhaseLevel2("");
      setCatalogPhaseLevel3("");
      setCatalogPhaseLevel4("");

      dispatch(startLoadingCatalogPhasesPaginated(pageInitial, itemsPerPage));

    }
  };

  const handleChangePhaseLevel2 = (event) => {

    if (event != null) {

      setIsDisabledSearchText(true);
      setIsDisabledFilter(false);



      setCatalogPhaseLevel2(event);

      dispatch(cleanCatalogPhaseLevel2());

      dispatch(selectCatalogPhaseLevel2(event));

      setCatalogPhaseLevel3("");
      setCatalogPhaseLevel4("");

      dispatch(startLoadingCatalogPhasesPaginated(pageInitial, itemsPerPage, event));

      dispatch(startLoadingCatalogPhaseByParent(event.id, 3));
    } else {

      //setIsDisabledSearchText(false);
      setIsDisabledFilter(false);


      dispatch(cleanCatalogPhaseLevel2());
      setCatalogPhaseLevel2("");
      setCatalogPhaseLevel3("");
      setCatalogPhaseLevel4("");

      dispatch(startLoadingCatalogPhasesPaginated(pageInitial, itemsPerPage, catalogPhaseLevel1));

    }
  };

  const handleChangePhaseLevel3 = (event) => {

    if (event != null) {

      setIsDisabledSearchText(true);
      setIsDisabledFilter(false);



      setCatalogPhaseLevel3(event);

      dispatch(cleanCatalogPhaseLevel3());

      dispatch(selectCatalogPhaseLevel3(event));

      setCatalogPhaseLevel4("");

      dispatch(startLoadingCatalogPhasesPaginated(pageInitial, itemsPerPage, event));

      dispatch(startLoadingCatalogPhaseByParent(event.id, 4));
    } else {

      //setIsDisabledSearchText(false);
      setIsDisabledFilter(false);



      dispatch(cleanCatalogPhaseLevel3());
      setCatalogPhaseLevel3("");
      setCatalogPhaseLevel4("");

      dispatch(startLoadingCatalogPhasesPaginated(pageInitial, itemsPerPage, catalogPhaseLevel2));

    }
  };

  const handleChangePhaseLevel4 = (event) => {

    if (event != null) {

      setIsDisabledSearchText(true);
      setIsDisabledFilter(false);



      setCatalogPhaseLevel4(event);

      dispatch(cleanCatalogPhaseLevel4());

      dispatch(selectCatalogPhaseLevel4(event));

      dispatch(startLoadingCatalogPhasesPaginated(pageInitial, itemsPerPage, event));

      dispatch(startLoadingCatalogPhaseByParent(event.id, 5));
    } else {

      //setIsDisabledSearchText(false);
      setIsDisabledFilter(false);


      dispatch(selectCatalogPhaseLevel4(event));
      setCatalogPhaseLevel4("");

      dispatch(startLoadingCatalogPhasesPaginated(pageInitial, itemsPerPage, catalogPhaseLevel3));

    }
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,

      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      
      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
  };

  return (
    <>
      <NavbarIconsCatalogPhases page={"listCatalogPhases"} />

      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <div className="container">
        <div className="row">

          {/* catalogPhaseId */}
          {/* Level1 */}
          <div className="col-md-4">
            <label className="form-label label-information">{t(`${ID_FORM}.filter.level1`)}</label>
            <div className="control">
              <Select
                styles={customStyles}
                myFontSize="14px"
                onChange={handleChangePhaseLevel1}
                classNamePrefix="select"
                name="catalogPhaseLevel1"
                value={catalogPhaseLevel1}
                options={listCatalogPhasesLevel1}
                getOptionLabel={(option) => `${option.code} - ${option.name}`}
                getOptionValue={(option) => `${option}`}
                isClearable={true}
                isSearchable={true}
                isDisabled={isDisabledFilter}
              />
            </div>
          </div>

          {/* Level2 */}
          <div className="col-md-4">
            <label className="form-label label-information">{t(`${ID_FORM}.filter.level2`)}</label>
            <div className="control">
              <Select
                styles={customStyles}
                myFontSize="14px"
                onChange={handleChangePhaseLevel2}
                classNamePrefix="select"
                name="catalogPhaseLevel2"
                value={catalogPhaseLevel2}
                options={listCatalogPhasesLevel2}
                getOptionLabel={(option) => `${option.code} - ${option.name}`}
                getOptionValue={(option) => `${option}`}
                isClearable={true}
                isSearchable={true}
                isDisabled={isDisabledFilter}
              />

            </div>
          </div>

          {/* Level3 */}
          <div className="col-md-4">
            <label className="form-label label-information">{t(`${ID_FORM}.filter.level3`)}</label>
            <div className="control">
              <Select
                styles={customStyles}
                myFontSize="14px"
                onChange={handleChangePhaseLevel3}
                classNamePrefix="select"
                name="catalogPhaseLevel3"
                value={catalogPhaseLevel3}
                options={listCatalogPhasesLevel3}
                getOptionLabel={(option) => `${option.code} - ${option.name}`}
                getOptionValue={(option) => `${option}`}
                isClearable={true}
                isSearchable={true}
                isDisabled={isDisabledFilter}
              />

            </div>
          </div>

          {/* Level4 */}
          <div className="col-md-4">
            <label className="form-label label-information">{t(`${ID_FORM}.filter.level4`)}</label>
            <div className="control">
              <Select
                styles={customStyles}
                myFontSize="14px"
                onChange={handleChangePhaseLevel4}
                classNamePrefix="select"
                name="catalogPhaseLevel4"
                value={catalogPhaseLevel4}
                options={listCatalogPhasesLevel4}
                getOptionLabel={(option) => `${option.code} - ${option.name}`}
                getOptionValue={(option) => `${option}`}
                isClearable={true}
                isSearchable={true}
                isDisabled={isDisabledFilter}
              />

            </div>
          </div>

        </div>
      </div>

      <hr className="line-hr" />

      <SearchBackCatalogPhase 
        searchText={searchText} 
        setSearchText={setSearchText} 
        itemsPerPage={itemsPerPage} 
        setIsDisabledSearchText={setIsDisabledSearchText}
        isDisabledSearchText={isDisabledSearchText}
        setIsDisabledFilter={setIsDisabledFilter}
        isDisabledFilter={isDisabledFilter}
        />

      {catalogPhasesS && catalogPhasesS.length > 0 ? (
        <TableCatalogPhases data={catalogPhasesS} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      ) : (
        <TableCatalogPhases data={catalogPhasesP} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      )}

      <div>
        <SimpleSelect listOptions={listOptions} onChangeSelect={onChangeSelect} pageSize={itemsPerPage} />
      </div>

      <div className="pagination justify-content-center">
        {catalogPhasesS && catalogPhasesS.length > 0 ? (
          <ReactPaginateComponent
            totalPages={totalPagesS}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChangeReactPaginate}
            currentPage={currentPageS}
            marginPagesDisplayed={5}
          />
        ) : (
          <ReactPaginateComponent
            totalPages={totalPagesP}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChangeReactPaginate}
            currentPage={currentPageS}
            marginPagesDisplayed={5}
          />
        )}
      </div>
    </>
  );
};

export default ListCatalogPhases;
